module.exports = __webpack_public_path__ + "img/pause.925e24f2.png";